import { gql, useQuery } from "@apollo/client";
import moment from "moment";
import React, {useState} from "react";
import { Icon } from "semantic-ui-react";
import CustomTable from "../../../Components/CustomTablePagination";
import DocumentResponse from "../../../Components/DocumentResponse";

const Requests = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const { loading, error, data } = useQuery(REQUESTS, {
    variables: { pagina: {limit:pageLimit, number:currentPage} },
    fetchPolicy: "network-only"
  });

  const columns = [
    {
      header: 'Nombre',
      accessor: 'documento.enunciado'
    },
    {
      header: 'Fecha',
      accessor: 'fechaCreacion',
      render: date => moment(date).format('DD-MM-YYYY h:mm:ss A')
    },
    {
      header: 'Fecha de actualización',
      accessor: 'fechaActualizacion',
      render: date => moment(date).format('DD-MM-YYYY h:mm:ss A')
    },
    {
      header: 'Estado solicitud',
      accessor: 'estadoSolicitud.valorParametro'
    },
    {
      header: 'Detalle',
      accessor: 'id',
      render: id => <DocumentResponse trigger={<Icon name="arrow alternate circle right" link />} id={id} />
    }
  ];

  return (
    <CustomTable
      error={error}
      loading={loading}
      columns={columns}
      data={data?.multiSolicitudesSesion.items}
      currentPage={currentPage}
      onPageChange={(e, { activePage }) => setCurrentPage(activePage)}
      pageLimit={pageLimit}
      setPageLimit={setPageLimit}
      setCurrentPage={setCurrentPage}
      totalPages={data?.multiSolicitudesSesion?.totalPages || 0}/>
  );
};

const REQUESTS = gql`
query requests($pagina: PageInput!) {
  multiSolicitudesSesion (
    filtro: { estado: ACTIVO },
    orden: { direccion: DESC , campo: FECHA_CREACION }
    pagina: $pagina 
    ) {
    items {
      id
    fechaCreacion
    fechaActualizacion
    documento {
      id
      enunciado
    }
    estadoSolicitud {
      id
      valorParametro
    }
    estado
    }
    count
    totalPages
    page {
      number
      limit
    }
  }
}`;

export default Requests;